import { render, staticRenderFns } from "./EnterpriseLeasePrimaryOrder.vue?vue&type=template&id=672c3a24"
import script from "./EnterpriseLeasePrimaryOrder.vue?vue&type=script&lang=js"
export * from "./EnterpriseLeasePrimaryOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports